import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AssetManagement, AssetVerify, AssetView } from "@aptsi-types";
import { environment } from "@env";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHandlingService } from "../shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../asset-management-api-endpoints";

interface GetAssetViewsResponse {
  assetmanagementreports: AssetManagement[];
}

interface VerifyAssets {
  verify: AssetVerify[];
}

@Injectable({
  providedIn: "root",
})
export class AssetManagementReportService {
  private readonly assetmanagementreportsUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}
  
  getAmReports(selectedFilter: string): Observable<AssetManagement[]> {
    return this.http
      .post<GetAssetViewsResponse>(
        `${this.assetmanagementreportsUrl}${API_ENDPOINTS.REPORTS.FETCH}`,
        { selectedFilter }
      )
      .pipe(
        map((response) => response.assetmanagementreports),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

    getAmDashboardChartData( selectedFilter: string): Observable<AssetManagement[]> {
      return this.http
        .post<GetAssetViewsResponse>(
          `${this.assetmanagementreportsUrl}${API_ENDPOINTS.DASHBOARD.FETCHCHARTDATA}`,
          { selectedFilter}
        )
        .pipe(
          map((response) => response.assetmanagementreports),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

}
